import { benefitsFromInvisible, invisibleEffects } from '../../../../shared/rules/effects/invisibility.mjs';
import { getSkillTraining } from '../../../../shared/rules/abilityChecks.mjs';
import { jackOfAllTradesBonus } from '../../../../shared/rules/classExpertise';
export const CUNNING_ACTION_FEATURE_ID = 'rogue:cunning-action';
export const HIDDEN_INVISIBLE_DEFINITION_ID = 'condition:invisible';

const entryName = (entry = {}) => String(entry.Name ?? entry.Occupation ?? entry.name ?? entry.occupation ?? '').trim().toLowerCase();
const entryLevel = (entry = {}) => Number(entry.Level ?? entry.level ?? entry.Levels ?? entry.levels) || 0;

export const getRogueLevel = (character = {}) => (Array.isArray(character.occupation) ? character.occupation : [])
  .reduce((total, entry) => entryName(entry) === 'rogue' ? total + entryLevel(entry) : total, 0);

export const hasCunningAction = (character) => getRogueLevel(character) >= 2;

export const getStealthCheckBonus = (character = {}, dexterityModifier = 0, proficiencyBonus = 0) => {
  const stealth = getSkillTraining(character, 'stealth');
  const multiplier = stealth.expertise ? 2 : stealth.proficient ? 1 : 0;
  return (Number(dexterityModifier) || 0) + (Number(proficiencyBonus) || 0) * multiplier + jackOfAllTradesBonus(character, proficiencyBonus, stealth.proficient);
};

export const getHideEffect = (combatState, combatantId) => (combatState?.activeEffects || []).find((effect) =>
  effect?.definitionId === HIDDEN_INVISIBLE_DEFINITION_ID && effect?.targetCombatantId === String(combatantId) &&
  effect?.sourceFeature === 'action:hide') || null;

const invisibleSource = (combatState, combatantId, observerId, castingSpell = false) => {
  const effective = castingSpell ? { ...combatState, activeEffects: (combatState?.activeEffects || []).filter(effect =>
    !(String(effect.targetCombatantId) === String(combatantId) && (effect.breakOn || []).includes('spellCast'))) } : combatState;
  if (!benefitsFromInvisible(effective, combatantId, observerId)) return null;
  return invisibleEffects(effective, combatantId).some(effect => effect.sourceFeature === 'action:hide') ? 'Invisible (Hidden)' : 'Invisible';
};
export const getInvisibleAttackSources = (combatState, attackerId, targetId, { castingSpell = false } = {}) => {
  const attacker = invisibleSource(combatState, attackerId, targetId, castingSpell);
  const target = invisibleSource(combatState, targetId, attackerId);
  return { advantageSources: attacker ? [attacker] : [], disadvantageSources: target ? [`Target ${target}`] : [] };
};

export const isDisengagedThisTurn = (combatState, combatantId) => {
  const ledger = combatState?.turnActionLedger;
  return Boolean(ledger?.combatantId === String(combatantId) && ledger?.turnSequence === combatState?.turnSequence &&
    ledger.turnStates?.some((state) => state.definitionId === 'action:disengage' && state.combatantId === String(combatantId)));
};

